import styled from "@emotion/styled";

export const ConfirmationModalContainer = styled.div`
  text-align: center;
  font-size: 1.3rem;
  margin: 1rem;
`;
